import { useEffect, useRef, useState } from "react";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import ModalStateDialogComponent from "../../cubeComponent/html/modal/ModalWithState";
import css from "./index.module.css";
import { RxCrossCircled } from "react-icons/rx";
import { inviteUsersUrl, portalCompaniesService } from "../../services/dataManager";
import DropDownListComponent from "../../cubeComponent/form/DropdownListComponent";
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import axiosWrapper from "../../services/axiosWrapper";
import { useDispatch, useSelector } from "react-redux";
import { getPortalProfiles } from "../../actions/portalSetting.helper";
import { showToastNotification } from "../../actions/toast";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "../../services/constants";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import { PlusIcon } from "@Components/StickySidebarViewer/assets/selectionIcons";
import { useTranslation } from "react-i18next";

function AddUserToPortal({ isVisible, setOpenAddUserModal }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { profileData, layout } = useSelector((state) => state);
  const passwordRef = useRef([{ enabled: false }]);

  const defaultUserDetails = {
    userName: "",
    email: "",
    id: "",
    companyRole: "",
    password: "",
    userId: "",
  };
  const [userData, setUserData] = useState([defaultUserDetails]);
  // const [newOrgData, setNewOrgData] = useState({});
  const [inviteButtonEnabled, setInviteButtonEnabled] = useState(false);
  const validateEmail = () => {
    let allowInvite = true;
    userData.forEach((x) => {
      if (typeof x.email == "string" && (!layout.ENABLE_INVITE_USER_WITHOUT_EMAIL || x.email)) {
        allowInvite = String(x.email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          );
      }
    });
    return allowInvite;
  };
  const handleInviteUsers = async () => {
    if (validateEmail()) {
      const response = await axiosWrapper.post(inviteUsersUrl, userData);
      if (!response.data.status) {
        dispatch(
          showToastNotification({
            content: response.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
      } else {
        dispatch(
          showToastNotification({
            content: t("Invitation sent successfully"),
            type: TOAST_TYPE_SUCCESS,
          }),
        );
        setUserData([defaultUserDetails]);
        setOpenAddUserModal(false);
      }
    } else {
      dispatch(
        showToastNotification({
          content: t("Invalid Format!"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  useEffect(() => {
    dispatch(getPortalProfiles());
  }, []);

  useEffect(() => {
    if (userData.length) {
      let enabled = true;
      for (const user of userData) {
        if (!user.id || !user.roleId || !user.userId || !user.userName) {
          enabled = false;
          break;
        }
      }
      setInviteButtonEnabled(enabled);
    }
  }, [userData]);

  // useEffect(() => {
  //   if (profileData.length > 0) {
  //     let filteredPortalRole = profileData;
  //     if (props.userDetails?.portalRole?.roleName == 'PORTAL_SUPER_ADMIN' && props.userDetails.portalRole.isDefaultRole) {
  //       setPortalRoles(filteredPortalRole);
  //     } else {
  //       filteredPortalRole = filteredPortalRole.filter((item) => item.roleName != 'PORTAL_SUPER_ADMIN');
  //       setIsFilteredRoles(true);
  //     }
  //     setPortalRoles(filteredPortalRole);
  //   }
  // }, [profileData]);

  const handleCloseModal = () => {
    setOpenAddUserModal(false);
    setUserData([defaultUserDetails]);
  };

  const handleUserDetailsChange = (e) => {
    handleInputChange(e.target);
  };

  const handleUserDropdownChange = (e) => {
    handleInputChange(e);
  };

  const handleInputChange = (e) => {
    const index = e.element.attributes["data-index"].value;
    const tempUserData = [...userData];
    const name = e.element.attributes["data-name"].value;

    if (name == "email") {
      if (tempUserData[index].email == tempUserData[index].userId) {
        tempUserData[index].userId = e.value;
      }

      if (e.value != "") {
        tempUserData[index].password = "";
        passwordRef.current[index].value = "";
        passwordRef.current[index].enabled = false;
      } else {
        passwordRef.current[index].enabled = true;
      }
    }

    tempUserData[index][name] = e.value;
    setUserData(tempUserData);
  };

  const handleAddRow = () => {
    setUserData((userData) => [...userData, defaultUserDetails]);
    passwordRef.current.push({ enabled: false });
  };

  const handleRemoveRow = (e) => {
    const index = e.currentTarget.attributes["data-index"].value;
    const tempUserData = [...userData];
    tempUserData.splice(index, 1);
    setUserData(tempUserData);
  };

  // const handleCreateOrg = async (e) => {
  //   const response = await axiosWrapper.post(portalCompaniesUrl, {
  //     action: "insert",
  //     value: newOrgData,
  //   });
  //   if (response.data.status) {
  //     dispatch(
  //       showToastNotification({
  //         content: `${response.data.data.companyId} Org created successfully`,
  //         type: TOAST_TYPE_SUCCESS,
  //       }),
  //     );
  //   } else {
  //     dispatch(
  //       showToastNotification({
  //         content: SOMETHING_WENT_WRONG,
  //         type: TOAST_TYPE_ERROR,
  //       }),
  //     );
  //   }
  // };

  // const handleNewOrgData = (e) => {
  //   const name = e.target.element.attributes["data-name"].value;
  //   setNewOrgData({
  //     ...newOrgData,
  //     [name]: e.value,
  //   });
  // };

  return (
    <>
      <ModalStateDialogComponent
        padding="var(--size-32)"
        footerContent={
          <div className={css.footer} data-testid="inviteUserBtnRow">
            <ButtonComponent
              disabled={!userData.length || !inviteButtonEnabled}
              buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
              onClick={handleInviteUsers}
            >
              {t("Invite User(s)")}
            </ButtonComponent>
          </div>
        }
        headerTitle="Add User(s) to Portal"
        width="67%"
        onCancel={handleCloseModal}
        isVisible={isVisible}
        modelContent={
          <>
            <div className={css.addAddUserButton} data-testid="handleAddUserRow">
              <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} onClick={handleAddRow}>
                <div className={css.addUSerButton} data-testid="addUserBtn">
                  <PlusIcon color="var(--primary-text)" />
                  <span data-testid="addUserBtnText">{t("Add User")}</span>
                </div>
              </ButtonComponent>
            </div>
            <div className="pb-6">
              <div className={css.body}>
                {userData.map((user, index) => (
                  <div key={index} className={css.addUserfieldsWrapper} data-testid="addUserfieldsWrapper">
                    <div key={index} className={css.row}>
                      {/* TODO: div is used for css only. */}
                      <div className={css.componentClass}>
                        <TextBoxComponent
                          placeholder={t("Enter UserName")}
                          data-name="userName"
                          value={user.userName}
                          data-index={index}
                          onChange={handleUserDetailsChange}
                          data-testid="userName"
                        />
                      </div>
                      <div className={css.componentClass}>
                        <TextBoxComponent
                          placeholder={t("Enter User E-mail")}
                          data-name="email"
                          value={user.email}
                          data-index={index}
                          onChange={handleUserDetailsChange}
                          data-testid="userEmail"
                        />
                      </div>
                      {layout.ENABLE_INVITE_USER_WITHOUT_EMAIL && (
                        <div className={css.componentClass}>
                          <TextBoxComponent
                            placeholder={t("Enter User ID")}
                            data-name="userId"
                            value={user.userId}
                            data-index={index}
                            onChange={handleUserDetailsChange}
                            data-testid="userId"
                          />
                        </div>
                      )}
                      {layout.ENABLE_INVITE_USER_WITHOUT_EMAIL && (
                        <div className={css.componentClass}>
                          <TextBoxComponent
                            ref={(e) => (passwordRef.current[index] = e)}
                            placeholder={t("Enter Password")}
                            data-name="password"
                            value={user.password}
                            data-index={index}
                            onChange={handleUserDetailsChange}
                            data-testid="password"
                          />
                        </div>
                      )}
                      <div className={css.componentClass}>
                        <DropDownListComponent
                          buttonType={BUTTON_TYPES.DROPDOWN_BACKGROUND_BUTTON}
                          placeholder={t("Select Organization")}
                          value={user.id}
                          fields={{ text: "name", value: "id" }}
                          data-name="id"
                          data-index={index}
                          dataSource={portalCompaniesService}
                          change={handleUserDropdownChange}
                          width="100%"
                          data-testid="selectOrg"
                        />
                      </div>
                      <div className={css.componentClass}>
                        <DropDownListComponent
                          buttonType={BUTTON_TYPES.DROPDOWN_BACKGROUND_BUTTON}
                          placeholder={t("Select Role")}
                          value={user.roleId}
                          data-name="roleId"
                          data-index={index}
                          fields={{ text: "frontendName", value: "id" }}
                          dataSource={profileData}
                          change={handleUserDropdownChange}
                          width="100%"
                          data-testid="selectRole"
                        />
                      </div>
                    </div>
                    <div data-testid="handleRemoveRow">
                      <RxCrossCircled data-index={index} onClick={handleRemoveRow} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        }
      />
    </>
  );
}

export default AddUserToPortal;
